export default __webpack_public_path__ + "static/media/sideeffects@3x.b44f3cd8.jpg";